import React from "react";
import { useSelector } from "react-redux";
const UserInfo = () => {
  const { user } = useSelector((state) => state.auth);
  

  const currentUser = {
    username: user?.name,
    image: user?.avatar?.url || "/img/default_avatar.jpg",
    email: user?.email,
    phone: user?.phone,
    website: user?.website,
    CompanyName: user?.CompanyName,
    customer_no: user?._id,
    createdAt: user?.createdAt.slice(0, 10),
  }
      


  return (
    <section className="w-full justify-between gap-[16px] md:gap-[200px] items-center md:flex-row flex flex-col">
      <div className="flex gap-12 items-center">
        <figure className="size-32 border bg-white rounded-full flex items-center justify-center relative shrink-0">
          {currentUser.image ? (
            <img
              className="w-full h-full object-cover rounded-full"
              src={currentUser.image}
              alt={user?.name}
            />
          ) : (
            <h3 className="font-bold text-3xl">
              {currentUser?.username.split(" ").map((n) => n[0])}
            </h3>
          )}
        </figure>
        <figcaption className="flex flex-col gap-3">
          <h2 className="font-bold text-2xl">{currentUser?.username}</h2>
          <p className="text-gray-500">
            Customer No: {currentUser?.customer_no}
          </p>
          <p className="text-gray-500">Email: {currentUser?.email}</p>
          <p className="text-gray-500">Phone: {currentUser?.phone}</p>
          <p className="text-gray-500">Website: {currentUser?.website}</p>
          <p className="text-gray-500">Company Name: {currentUser?.CompanyName}</p>

          <p className="text-gray-500">
            Joined: {(currentUser?.createdAt)}
          </p>
        </figcaption>
      </div>
      <div className="w-full rounded-lg py-6 px-4 flex flex-col gap-6">
        <p className="text-xl">Track and Manage my Order</p>
        {/* TODO: Handle form */}
        <form className="flex items-center h-12 gap-6">
          <input
            type="text"
            placeholder="Order Number"
            className="border rounded-lg h-full px-6 w-full md:w-auto"
          />
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-0 h-full rounded-lg w-full md:w-auto">
            Track Order
          </button>
        </form>
      </div>
    </section>
  );
};

export default UserInfo;
